import {useBlockProps, useInnerBlocksProps} from '@wordpress/block-editor';
import {__} from '@wordpress/i18n';
import {buildCreditProperties} from "./tools";
import VideoThumbnail from "./components/videoThumbnail";

export default function save({attributes}) {
    const {videoUrl, videoThumbnails, videoTitle, credit, hasCreditOverlap, hasCaption, backgroundColor, style} = attributes;

    const blockProps = useBlockProps.save();
    const captionBlocksProps = useInnerBlocksProps.save({className: 'simple-video-preview__caption'});

    const {creditClassName, creditInnerClassName, creditInnerStyle} = buildCreditProperties({
        hasCreditOverlap,
        backgroundColor,
        style,
        blockProps
    });

    return videoUrl ? (
        <div className={blockProps.className}>
            <div className="simple-video-preview">
                <figure>
                      <span className="simple-video-preview__container">
                        <a
                            className="simple-video-preview__link"
                            title={videoTitle ? __('Watch %%videoTitle%% (new tab)', 'simple-video-preview').replace('%%videoTitle%%', `"${videoTitle}"`) : __('Watch video (new tab)', 'simple-video-preview')}
                            href={videoUrl}
                            target="_blank"
                            rel="noopener noreferrer">
                            {videoThumbnails ? (
                                <VideoThumbnail
                                    thumbnails={videoThumbnails}
                                    videoTitle={videoTitle}
                                />
                            ) : null}
                        </a>
                      </span>
                    {credit && (
                        <span className={creditClassName}>
                            <span className={creditInnerClassName} style={creditInnerStyle}>{credit}</span>
                        </span>
                    )}
                    {hasCaption && (
                        <figcaption {...captionBlocksProps} />
                    )}
                </figure>
            </div>
        </div>
    ) : '';
}
